(function () {
  var root = document.querySelector('[data-pl-pdp]');
  var cfgEl = document.querySelector('[data-pl-config]');
  if (!root || !cfgEl) return;
  var cfg = JSON.parse(cfgEl.textContent);
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents) {
    var v = (Math.round(cents) / 100).toFixed(2);
    var fmt = cfg.moneyFormat || '${{amount}}';
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }
  function $(sel, el) { return (el || root).querySelector(sel); }
  function $$(sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); }

  /* ---------- gallery ---------- */
  var slides = $$('.pl-gal__img'), thumbs = $$('[data-pl-thumb]'), cur = 0;
  function show(i) {
    if (!slides.length) return;
    cur = (i + slides.length) % slides.length;
    slides.forEach(function (s, j) { s.classList.toggle('is-on', j === cur); });
    thumbs.forEach(function (t, j) { t.setAttribute('aria-selected', j === cur ? 'true' : 'false'); });
    var c = $('[data-pl-count]'); if (c) c.textContent = (cur + 1) + ' / ' + slides.length;
  }
  thumbs.forEach(function (t, j) { t.addEventListener('click', function () { show(j); }); });
  var prev = $('[data-pl-prev]'), next = $('[data-pl-next]');
  if (prev) prev.addEventListener('click', function () { show(cur - 1); });
  if (next) next.addEventListener('click', function () { show(cur + 1); });
  if (slides.length < 2) { if (prev) prev.hidden = true; if (next) next.hidden = true; }
  show(0);

  /* ---------- variants ---------- */
  function sideOf(v) { return /left/i.test(v.o1 || '') ? 'Left' : /right/i.test(v.o1 || '') ? 'Right' : null; }
  function findVariant(side, size) {
    for (var i = 0; i < cfg.variants.length; i++) {
      var v = cfg.variants[i];
      if (sideOf(v) === side && String(v.o2).toUpperCase() === size.toUpperCase()) return v;
    }
    return null;
  }

  /* ---------- state ---------- */
  var offers = {
    1: { price: cfg.base, was: cfg.baseWas, per: 'Per sleeve', title: '1 sleeve' },
    2: { price: cfg.price2, was: cfg.baseWas * 2, per: 'For 2 sleeves', title: '2 sleeves · both knees' },
    4: { price: cfg.price4, was: cfg.baseWas * 4, per: 'For 4 sleeves', title: '4 sleeves' }
  };
  var state = { offer: 1, items: [{ side: null, size: null }] };

  function setOffer(n) {
    var items = state.items.slice(0, n);
    while (items.length < n) items.push({ side: null, size: null });
    state.offer = n; state.items = items; status('');
    render();
  }
  function setItem(i, patch) {
    var it = state.items[i];
    for (var k in patch) it[k] = patch[k];
    if (i === 0 && patch.size) state.items.forEach(function (x, j) { if (j > 0 && !x.size) x.size = patch.size; });
    status('');
    render();
  }

  function readiness() {
    var needSide = state.items.some(function (it) { return !it.side; });
    var needSize = state.items.some(function (it) { return !it.size; });
    return { needSide: needSide, needSize: needSize, ready: !needSide && !needSize };
  }
  function summary() {
    var multi = state.items.length > 1;
    return multi
      ? state.items.map(function (it) { return (it.side === 'Right' ? 'R' : 'L') + ' ' + it.size; }).join(', ')
      : state.items[0].side + ' knee / ' + state.items[0].size;
  }

  var itemsEl = $('[data-pl-items]');
  function btn(cls, label, checked, aria, onClick, disabled) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'pl-opt ' + cls; b.setAttribute('role', 'radio');
    b.setAttribute('aria-checked', checked ? 'true' : 'false');
    if (aria) b.setAttribute('aria-label', aria);
    b.innerHTML = label; if (disabled) b.disabled = true;
    b.addEventListener('click', onClick);
    return b;
  }

  function renderItems() {
    var multi = state.items.length > 1;
    var focusKey = document.activeElement && document.activeElement.getAttribute('data-k');
    itemsEl.innerHTML = '';
    state.items.forEach(function (it, i) {
      var done = it.side && it.size;
      var card = document.createElement('div');
      card.className = 'pl-item' + (multi ? ' is-multi' : '') + (done ? ' is-done' : '');
      card.setAttribute('role', 'group'); card.setAttribute('aria-label', 'Sleeve ' + (i + 1));
      card.innerHTML = '<div class="pl-item__head"><span class="pl-item__label">Sleeve ' + (i + 1) + '</span><span class="pl-item__status">' +
        (done ? '✓ ' + it.side + ' knee · ' + it.size : 'Not chosen yet') + '</span></div>';
      var sides = document.createElement('div');
      sides.className = 'pl-sides'; sides.setAttribute('role', 'radiogroup'); sides.setAttribute('aria-label', 'Sleeve ' + (i + 1) + ' knee');
      ['Right', 'Left'].forEach(function (s) {
        var b = btn('pl-opt--side', s + ' knee', it.side === s, null, function () { setItem(i, { side: s }); });
        b.setAttribute('data-k', i + 'side' + s); sides.appendChild(b);
      });
      var sizes = document.createElement('div');
      sizes.className = 'pl-sizes'; sizes.setAttribute('role', 'radiogroup'); sizes.setAttribute('aria-label', 'Sleeve ' + (i + 1) + ' size');
      cfg.sizes.forEach(function (z, k) {
        var v = it.side ? findVariant(it.side, z) : null;
        var soldOut = it.side && (!v || !v.available);
        var b = btn('pl-opt--size', '<b>' + z + '</b><small>' + cfg.lbs[k] + '</small>', it.size === z, z + ', ' + cfg.lbs[k] + (soldOut ? ', sold out' : ''), function () { setItem(i, { size: z }); }, soldOut);
        b.setAttribute('data-k', i + 'size' + z); sizes.appendChild(b);
      });
      card.appendChild(sides); card.appendChild(sizes);
      itemsEl.appendChild(card);
    });
    if (focusKey) { var f = itemsEl.querySelector('[data-k="' + focusKey + '"]'); if (f) f.focus(); }
  }

  function render() {
    var o = offers[state.offer], r = readiness();
    $$('[data-pl-offer]').forEach(function (b) { b.setAttribute('aria-checked', String(+b.getAttribute('data-pl-offer') === state.offer)); });
    $$('[data-pl-price]').forEach(function (e) { e.textContent = money(o.price); });
    $$('[data-pl-was]').forEach(function (e) { e.textContent = o.was > o.price ? money(o.was) : ''; });
    var save = $('[data-pl-save]');
    if (save) { save.textContent = o.was > o.price ? 'Save ' + money(o.was - o.price) : ''; save.hidden = !(o.was > o.price); }
    var per = $('[data-pl-per]'); if (per) per.textContent = o.per;
    var pt = $('[data-pl-picktitle]'); if (pt) pt.textContent = state.items.length > 1 ? 'Choose knee + size for each sleeve' : 'Choose knee + size';
    var label = r.needSide ? 'Select knee & size' : r.needSize ? 'Select your size' : 'Add to cart';
    $$('[data-pl-cta]').forEach(function (b) { if (b.getAttribute('aria-busy') !== 'true') b.textContent = label; });
    var sum = $('[data-pl-sticky-sum]');
    if (sum) sum.textContent = r.ready ? 'PatelLock · ' + summary() : 'PatelLock · ' + o.title + ' · ' + (r.needSide ? 'select knee & size' : 'select size');
    $$('[data-pl-sizerow]').forEach(function (row) {
      var z = row.getAttribute('data-pl-sizerow');
      row.classList.toggle('is-on', state.items.some(function (it) { return it.size === z; }));
    });
    renderItems();
    if (typeof syncForm === 'function') syncForm();
  }

  $$('[data-pl-offer]').forEach(function (b) { b.addEventListener('click', function () { setOffer(+b.getAttribute('data-pl-offer')); }); });

  /* ---------- cart ---------- */
  var statusEl = $('[data-pl-status]');
  function status(msg, err) {
    if (!statusEl) return;
    statusEl.classList.toggle('is-error', !!err);
    statusEl.innerHTML = msg ? (err ? '' : '<span class="pl-check pl-check--sm" aria-hidden="true">✓</span>') + msg : '';
  }
  var mainCta = $('[data-pl-cta="main"]');
  function scrollToBuy() {
    var top = window.scrollY + mainCta.getBoundingClientRect().top - window.innerHeight * 0.6;
    window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
    var first = itemsEl.querySelector('.pl-item:not(.is-done) .pl-opt[aria-checked="false"]:not(:disabled)');
    if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, reduce ? 0 : 400);
  }

  var form = document.getElementById('pl-product-form');
  var inId = $('[data-pl-input-id]'), inQty = $('[data-pl-input-qty]');
  function syncForm() {
    var r = readiness();
    if (!r.ready) return;
    var first = findVariant(state.items[0].side, state.items[0].size);
    if (first && inId) inId.value = first.id;
    if (inQty) inQty.value = state.items.length;
    if (state.items.length === 1 && first && window.history.replaceState) {
      var u = new URL(window.location.href); u.searchParams.set('variant', first.id);
      window.history.replaceState({}, '', u.toString());
    }
  }
  function setCount(n) { var c = document.querySelector('[data-pl-cart-count]'); if (c && typeof n === 'number') c.textContent = n; }

  function addToCart() {
    var r = readiness();
    if (!r.ready) { scrollToBuy(); return; }
    var counts = {}, missing = false;
    state.items.forEach(function (it) {
      var v = findVariant(it.side, it.size);
      if (!v || !v.available) { missing = true; return; }
      counts[v.id] = (counts[v.id] || 0) + 1;
    });
    if (missing) { status('That knee and size is sold out. Please choose another size.', true); return; }
    var ids = Object.keys(counts);
    var ctas = $$('[data-pl-cta]').concat($$('[data-pl-buynow]'));
    ctas.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
    var actions = window.Shopify && window.Shopify.actions;
    var job;
    if (actions && actions.updateCart) {
      job = actions.updateCart(
        { lines: ids.map(function (id) { return { merchandiseId: 'gid://shopify/ProductVariant/' + id, quantity: counts[id] }; }) },
        { event: { context: 'product' } }
      ).then(function (res) {
        if (res && res.userErrors && res.userErrors.length) throw new Error(res.userErrors[0].message);
        if (res && res.cart) setCount(res.cart.totalQuantity);
        status('Added: ' + summary());
        if (!document.querySelector('theme-drawer#cart-drawer') && actions.openCart) return actions.openCart();
      });
    } else {
      job = fetch(cfg.cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: ids.map(function (id) { return { id: +id, quantity: counts[id] }; }) })
      }).then(function (res) {
        return res.json().then(function (data) { if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart'); return data; });
      }).then(function () { status('Added: ' + summary()); window.location.href = cfg.cartUrl; });
    }
    job.catch(function (e) {
      status((e && e.message) || 'Something went wrong. Please try again.', true);
    }).finally(function () {
      ctas.forEach(function (b) { b.removeAttribute('aria-busy'); });
      render();
    });
  }
  if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(); });
  var stickyCta = $('[data-pl-cta="sticky"]');
  if (stickyCta) stickyCta.addEventListener('click', addToCart);
  var buyNow = $('[data-pl-buynow]');
  if (buyNow) buyNow.addEventListener('click', function () { readiness().ready ? addToCart() : scrollToBuy(); });
  var cartBtn = document.querySelector('[data-pl-cartbtn]');
  if (cartBtn) cartBtn.addEventListener('click', function (e) {
    var d = document.querySelector('theme-drawer#cart-drawer');
    if (d && d.open) { e.preventDefault(); d.open(); }
  });

  /* ---------- sticky bar ---------- */
  var sticky = $('[data-pl-sticky]'), stickyBtn = $('[data-pl-cta="sticky"]'), on = false;
  function onScroll() {
    var s = mainCta.getBoundingClientRect().bottom < 0;
    if (s === on) return; on = s;
    sticky.classList.toggle('is-on', s);
    sticky.setAttribute('aria-hidden', s ? 'false' : 'true');
    stickyBtn.tabIndex = s ? 0 : -1;
    document.body.classList.toggle('has-sticky', s);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  /* ---------- FAQ ---------- */
  var faqBtns = $$('[data-pl-faq]');
  faqBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      var open = b.getAttribute('aria-expanded') === 'true';
      faqBtns.forEach(function (o) {
        var isMe = o === b && !open;
        o.setAttribute('aria-expanded', String(isMe));
        o.querySelector('.pl-faq__icon').textContent = isMe ? '−' : '+';
        document.getElementById(o.getAttribute('aria-controls')).hidden = !isMe;
        o.closest('.pl-faq__item').classList.toggle('is-open', isMe);
      });
    });
  });

  render();
  onScroll();
})();